import { useEffect, useRef } from 'react';

/**
 * După login prin email, AuthContext ține răspunsul brut al /login
 * ({ message }) până la următoarea încărcare completă. Paginile Premium au
 * nevoie de profilul real (email, is_premium), așa că cer o reîmprospătare
 * o singură dată dacă lipsește.
 */
export function useEnsureProfile(auth) {
  const requested = useRef(false);
  useEffect(() => {
    if (requested.current) return;
    if (auth?.user && !auth.user.email && typeof auth.checkAuth === 'function') {
      requested.current = true;
      auth.checkAuth();
    }
  }, [auth]);
}
